// 备注：在setinterval中使用aysnc await语法，部分浏览器会报unexpected token function（建议使用.then()）
import axios from 'axios'
import badNetwork from '../../mp3/badNetwork.mp3'
var config = require('../../js/config.js')
var utils = require('../../js/utils/utility.js')

window.Promise = require('promise');

// 默认请求公共地址、头部信息
var domainUrl = config.address

var domainUrl2 = config.address2

var commomHeaders = config.commomHeaders
var configStorage = utils.storage.localGetItem('configStorage');
var courierToken = utils.storage.localGetItem('courierToken');

// adminpost请求
var adminPost = function (url, data) {
	data = data || '';
	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl + url,
			headers: commomHeaders,
			data: data
		})
		.then(function (res) {
			resolve(res.data)
		})
		.catch(function (error) {
			var url = badNetwork
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			utils.messageError('网络信号不良，请稍后再试')
			// console.log('error', error)
			utils.hideLoading()
			reject(error)
		})
	})
}

// post请求
var post = function (url, data ,token) {
	data = data || '';
	var headersObj = {
		'Authorization': token,
	}
	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl + url,
			headers: token ? headersObj : commomHeaders,
			data: data,
		})
		.then(function (res) {
			resolve(res.data)
		})
		.catch(function (error) {
			var url = badNetwork
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			utils.messageError('网络信号不良，请稍后再试')
			// console.log('error', error)
			utils.hideLoading()
			reject(error)
		})
		
	})
}

export {
	adminPost,
	post,
}



//////////////////
// WEBPACK FOOTER
// ./static/FreshCabinet/js/request.js
// module id = FrWQ
// module chunks = 1